module.exports = __webpack_public_path__ + "img/DK66671011.2f6f32a8.png";